import type { JSX } from "react";

import {
  Field,
  FieldContent,
  FieldLabel,
} from "@frontend/components/atoms/Field";
import { Input } from "@frontend/components/atoms/Input";
import { useField } from "@frontend/hooks/form";
import { useLingui } from "@lingui/react/macro";

import { projectForm } from "../stores/editor";
import { Section } from "./Section";

const fields = projectForm.fields;

/** What the project is billed against, and why that way. */
export function QuotationSection(): JSX.Element {
  const { t } = useLingui();

  const quotationNumber = useField(fields.quotationNumber);
  const justification = useField(fields.billingTypeJustification);

  return (
    <Section icon="FileSignature" legend={t`Quotation`} gutter={false}>
      <Field>
        <FieldLabel>{t`Quotation number`}</FieldLabel>

        <FieldContent>
          <Input
            value={quotationNumber.value ?? ""}
            onChange={(event) => quotationNumber.setValue(event.target.value)}
          />
        </FieldContent>
      </Field>

      <Field>
        <FieldLabel>{t`Reason`}</FieldLabel>

        <FieldContent>
          <Input
            value={justification.value ?? ""}
            onChange={(event) => justification.setValue(event.target.value)}
          />
        </FieldContent>
      </Field>
    </Section>
  );
}
